import React from 'react';

//import ApolloClient from 'apollo-boost';
import { gql } from "apollo-boost";


import './openPayForm/style.css';

type MyState = { 
     nombre: string, 
     email:string,  
     email_confirm:string
     cell:string
     cantidadDonar:string

     keyItem:string
};
   
type MyProps = {
     actionComplete:any
     clientAPollo:any
}
export class RegistroForm extends React.Component<MyProps, MyState>{
     submit: any;
     
     constructor(props:any) {
          super(props)

          this.state = {
               nombre: '',
               email: '',
               email_confirm:"",
               cell:'',

               cantidadDonar:"199",
               keyItem:''
             }

          this.handleChange = this.handleChange.bind(this);
          this.handleSubmit = this.handleSubmit.bind(this);             
     }

     updateState=(newStates:object)=> this.setState(newStates);

     handleChange(event: React.ChangeEvent<any>) {
          let { name, value } = event.currentTarget;
          this.setState({[name] : value} as any);
     }
     
     handleSubmit= async(event:any) => {
          this.submit.setAttribute("disabled", "disabled");

          event.preventDefault();

          try{
               if(this.state.email!==this.state.email_confirm)
                    throw new Error("Debe ser igual el campo email")

               console.log("Intento de registrar, Key:",this.state.keyItem,", Precio:",this.state.cantidadDonar);
               let response=await this.props.clientAPollo.mutate({
                    mutation: gql`
                         mutation createCardboardFanRegister($nombre:String, $email:String,$cell:String,$cantidad:Int,$key:String){
                              createCardboardFanRegister(input:{
                                   nombre:$nombre,
                                   email:$email,
                                   cell:$cell,
                                   cantidad:$cantidad,
                                   key:$key
                              }){
                                   id,
                                   cantidad
                         }}`,
                    variables:{
                         "nombre":this.state.nombre,
                         "email":this.state.email,
                         "cell":this.state.cell,
                         "cantidad":parseInt(this.state.cantidadDonar),
                         "key":this.state.keyItem  
                    }
               });          
               
               console.log("Se completo el registro:",response.data.createCardboardFanRegister.id)
               this.props.actionComplete(response.data.createCardboardFanRegister)
               
          }catch(e){
               console.log("ERROR:",JSON.stringify(e))
               //@ts-ignore
               Sentry.captureException(e);

               alert(e.message)
               this.submit.removeAttribute("disabled");
          }
     
          
     }     

     form_valid_email_repetido=(event:any) => {
          let Item:any=event.currentTarget

          if(this.state.email!==this.state.email_confirm)
               Item.setCustomValidity('El campo de confirmar Email debe ser igual al campo Email');
          else
               Item.setCustomValidity('');
          return true;
     }

     render= () =>
     <form id="formRegister" className="formulario" onSubmit={this.handleSubmit}>
          <input type="hidden" id="key" name="keyItem" value={this.state.keyItem} onChange={this.handleChange}/>

          <div className="form-group">
               <small id="blockHelp" className="form-text">Nombre completo</small>
               <input type="text" className="form-control" name="nombre" value={this.state.nombre} onChange={this.handleChange} required minLength={5} />
          </div>
          <div className="form-group">
               <small id="blockHelp" className="form-text">Email</small>
               <input type="email" className="form-control" name="email" value={this.state.email} onChange={this.handleChange} required />
          </div>
          <div className="form-group">
               <small id="blockHelp" className="form-text">Confirmar Email</small>
               <input type="email" className="form-control" name="email_confirm"   value={this.state.email_confirm} onChange={this.handleChange}
               required  onInvalid={this.form_valid_email_repetido} />
          </div>
          <div className="form-group">
               <small id="blockHelp" className="form-text">Teléfono celular</small>
               <input type="text" className="form-control" name="cell" value={this.state.cell}  onChange={this.handleChange} pattern="[0-9]{10}" title="Un número de 10 digitos" required />
          </div>
          <div className="form-group">
               <small id="blockHelp" className="form-text">Cantidad a donar</small>
               <ul className="radio-btn">
                    <li>
                         <label className="input customRadio" htmlFor="cantidadDonar199">
                              <input type="radio" name="cantidadDonar" value="199" id="cantidadDonar199"  checked={this.state.cantidadDonar === '199'} onChange={this.handleChange}   />
                              <span className="checkmark" />
                              <strong>$199</strong> - Silueta Rayada
                         </label>
                    </li> 
                    <li className="tachado">
                         <label className="input customRadio" htmlFor="cantidadDonar349">
                              <input type="radio" name="cantidadDonar" value="199" id="cantidadDonar349"  checked={this.state.cantidadDonar === '349'} onChange={this.handleChange}  />
                              <span className="checkmark" />
                              <strong>$349</strong> - Silueta Rayada + participas para llevártela autografiada
                         </label>
                    </li>
                    <li className="tachado">
                         <label className="input customRadio" htmlFor="cantidadDonar699">
                              <input type="radio" name="cantidadDonar" value="199" id="cantidadDonar699" checked={this.state.cantidadDonar === '699'} onChange={this.handleChange} />
                              <span className="checkmark" />
                              <strong>$699</strong> - Silueta Rayada + participas para jersey local PUMA 20-21
                         </label>
                    </li>                                        
               </ul>
          </div>                  

          <div className="buttom">
               <input type="submit" ref={itemRef => {this.submit = itemRef}}   className="btn  btn-block btn-fpmg" value="Generar pedido" />
          </div>

   </form>
}